/**
 * 即需要兼容1x1，又需要兼容3x4比例图片，所以需要图片ratio设置为full-width
 * 当图片错误时候，full-width会导致显示高度异常。所以在错误时候，设置为3x4比例。
 * 使用error切换渲染组件而不是切换ratio属性，是因为切换ratio属性会让图标显示失败
 */
import React, { useState } from "react";
import { Image } from "@common/DynamicUikit";

type Props = {
  src: string;
  alt: string;
};
const OverwriteImage = (props: Props) => {
  const [error, setError] = useState(false);
  return error ? (
    <Image
      src={""}
      alt={props.alt}
      ratio={"3x4"}
      noImage={{ imageSize: "small", imageType: "product" }}
    />
  ) : (
    <Image
      src={props.src}
      alt={props.alt}
      ratio={"full-width"}
      noImage={{ imageSize: "small", imageType: "product" }}
      onError={() => setError(true)}
    />
  );
};

export default OverwriteImage;
